<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top bg-danger transparent" @click="closeDrop()">
        <div class="container d-flex justify-content-between">
            
            <ul class="navbar-nav me-auto mb-2 mb-lg-0 ul-back">
                <li class="nav-item" v-if="btnHome && showBackBtnOut">
                    <router-link class="nav-link btn-back" :to="{name: 'homeLang'}"><i class="las la-home text-gradient-green"></i> Inicio</router-link>
                </li>
                <li class="nav-item" v-if="btnBack && showBackBtnOut">
                    <a class="nav-link btn-back pointer" @click="$router.back()"><i class="las la-angle-left text-gradient-green"></i> Volver</a>
                </li>
            </ul>
            
            <div class="" id="navbarSupportedContent">
                <form class="d-flex ">
                    <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                        <li class="nav-item dropdown flag-btn mt-1">
                            <a v-if="brCountry == 'ar'" drop="flags" class="nav-link dropdown-toggle text-start text-white" href="#" role="button" >
                                <img src="@/assets/imgs/flags/ar.png" class="img-fluid flag"> <span  drop="flags" class="btn-back pointer text-secondary">ARG / $ARS </span>
                            </a>
                            <a v-if="brCountry == 'cl'" @click="toggle" drop="flags" class="nav-link dropdown-toggle text-start text-white" href="#" role="button" >
                                <img src="@/assets/imgs/flags/cl.png" class="img-fluid flag"> <span  drop="flags" class="btn-back pointer text-secondary">CHI / $CLP </span>
                            </a>
                            <a v-if="brCountry == 'ec'" @click="toggle" drop="flags" class="nav-link dropdown-toggle text-start text-white" href="#" role="button" >
                                <img src="@/assets/imgs/flags/ec.png" class="img-fluid flag"> <span  drop="flags" class="btn-back pointer text-secondary">ECU / $USD </span>
                            </a>
                            <a v-if="brCountry == 'es'" @click="toggle" drop="flags" class="nav-link dropdown-toggle text-start text-white" href="#" role="button" >
                                <img src="@/assets/imgs/flags/es.png" class="img-fluid flag"> <span  drop="flags" class="btn-back pointer text-secondary">ESP / $EUR </span>
                            </a>
                            <a v-if="brCountry == 'pe'" @click="toggle" drop="flags" class="nav-link dropdown-toggle text-start text-white" href="#" role="button" >
                                <img src="@/assets/imgs/flags/pe.png" class="img-fluid flag"> <span  drop="flags" class="btn-back pointer text-secondary">PER / $SOL </span>
                            </a>
                            <a v-if="brCountry == 'co'" @click="toggle" drop="flags" class="nav-link dropdown-toggle text-start text-white" href="#" role="button" >
                                <img src="@/assets/imgs/flags/co.png" class="img-fluid flag"> <span  drop="flags" class="btn-back pointer text-secondary">COL / $COP </span>
                            </a>
                            <a v-if="brCountry == 'uy'" @click="toggle" drop="flags" class="nav-link dropdown-toggle text-start text-white" href="#" role="button" >
                                <img src="@/assets/imgs/flags/uy.png" class="img-fluid flag"> <span  drop="flags" class="btn-back pointer text-secondary">URU / $UYU </span>
                            </a>
                            <a v-if="brCountry == 'mx'" @click="toggle" drop="flags" class="nav-link dropdown-toggle text-start text-white" href="#" role="button" >
                                <img src="@/assets/imgs/flags/mx.png" class="img-fluid flag"> <span  drop="flags" class="btn-back pointer text-secondary">MEX / $MXN </span>
                            </a>
                            <a v-if="brCountry == 'us'" @click="toggle" drop="flags" class="nav-link dropdown-toggle text-start text-white" href="#" role="button" > 
                                <img src="@/assets/imgs/flags/eu.png" class="img-fluid flag"> <span  drop="flags" class="btn-back pointer text-secondary">OTHERS / $USD </span>
                            </a>
                            <a v-if="brCountry != 'ar' && brCountry != 'co' && brCountry != 'pe' && brCountry != 'ec' && brCountry != 'uy' && brCountry != 'cl' && brCountry != 'mx' && brCountry != 'us' && brCountry != 'es'" @click="toggle" drop="flags" class="nav-link dropdown-toggle text-center text-white" href="#" role="button" >
                                <img src="@/assets/imgs/flags/la.png" class="img-fluid flag"> <span  drop="flags" class="btn-back pointer text-secondary">LATAM / $USD </span>
                            </a>
                            <ul class="dropdown-menu flag-menu show mobile" v-if="DropActive">
                                <li><a class="dropdown-item" @click="changeCountry('AR')" :href="'/ar/es'+this.actualPage"><img src="@/assets/imgs/flags/ar.png" class="img-fluid flag"> Argentina / $ARS</a></li>
                                <li><a class="dropdown-item" @click="changeCountry('CL')" :href="'/cl/es'+this.actualPage"><img src="@/assets/imgs/flags/cl.png" class="img-fluid flag"> Chile / $CLP</a></li>
                                <li><a class="dropdown-item" @click="changeCountry('CO')" :href="'/co/es'+this.actualPage"><img src="@/assets/imgs/flags/co.png" class="img-fluid flag"> Colombia / $COP</a></li>
                                <li><a class="dropdown-item" @click="changeCountry('EC')" :href="'/ec/es'+this.actualPage"><img src="@/assets/imgs/flags/ec.png" class="img-fluid flag"> Ecuador / $USD</a></li>
                                <li><a class="dropdown-item" @click="changeCountry('ES')" :href="'/es/es'+this.actualPage"><img src="@/assets/imgs/flags/es.png" class="img-fluid flag"> España / $EUR</a></li>
                                <li><a class="dropdown-item" @click="changeCountry('MX')" :href="'/mx/es'+this.actualPage"><img src="@/assets/imgs/flags/mx.png" class="img-fluid flag"> Mexíco / $MXN</a></li>
                                <li><a class="dropdown-item" @click="changeCountry('PE')" :href="'/pe/es'+this.actualPage"><img src="@/assets/imgs/flags/pe.png" class="img-fluid flag"> Perú / $SOL</a></li>
                                <li><a class="dropdown-item" @click="changeCountry('UY')" :href="'/uy/es'+this.actualPage"><img src="@/assets/imgs/flags/uy.png" class="img-fluid flag"> Uruguay / $UYU</a></li>
                                <li><a class="dropdown-item" @click="changeCountry('LA')" :href="'/la/es'+this.actualPage"><img src="@/assets/imgs/flags/la.png" class="img-fluid flag"> Latam / $USD</a></li>
                                <li><a class="dropdown-item" @click="changeCountry('US')" :href="'/us/es'+this.actualPage"><img src="@/assets/imgs/flags/eu.png" class="img-fluid flag"> Resto del Mundo / $USD</a></li> 
                            </ul>
                        </li>    
                    </ul>
                </form>
            </div>
        </div>
    </nav>
</template>
<script>
import userHello from '@/components/nav/user-hello.vue' 
export default {   
    name: "navbar",
    props: ['showReg', 'showLogin', 'showItems', 'showComunity', 'toggleFlags', 'showName', 'btnHome', 'btnBack', 'showBackBtnOut'],
    data () {
      return {
        DropActive: false,
        DropActiveRegister: false,
        mobileDrop: false,
        isDrop: false,
        brCountry: '',
        brLang: '',
        actualPage: '',
        isLog: false,
        userName: '',
        lastDrop: ''
      }
    },
    components: {
        userHello
    }, 
    mounted: function () {  
        if(localStorage.getItem('token')){
            if(localStorage.getItem('token') != ''){
                var data = JSON.parse(localStorage.getItem('userData'));
                this.userName = data.userFirstName;
                if(data.userType == 1){
                    this.isLog = true;
                }
            }
        }
        document.querySelector("body").addEventListener("click", this.getElem);    
        if(window.innerWidth > 720){
            this.mobileDrop = true;
        }
        this.brCountry = this.$route.params.browserCountry;
        this.brLang = this.$route.params.userLang;
        this.actualPage = document.baseURI.split(window.location.host+'/'+this.brCountry+'/'+this.brLang);
        this.actualPage = this.actualPage[1];   
    },
    methods: {
        changeCountry(val){
            localStorage.setItem('routeCountry', val);
        },
        toggleRegister () {
            this.DropActiveRegister = !this.DropActiveRegister
        },
        toggleMobile () {
            this.mobileDrop = !this.mobileDrop
            if(window.innerWidth > 720){
                this.mobileDrop = true;
            }
        },
        getElem(el){

            var e;
            try{
                e = el.target.attributes.drop.nodeValue;  
            }
            catch(error){

            }    
            if(e == 'flags'){
                if(this.lastDrop == 'flags'){ 
                    this.DropActive = false;
                    this.lastDrop = '';
                }else{
                    this.DropActive = true;
                    this.lastDrop = e;
                }
                this.DropActiveRegister = false;  
            }
            if(e == 'register'){
                if(this.lastDrop == 'register'){ 
                    this.DropActiveRegister = false;
                    this.lastDrop = '';
                }else{
                    this.DropActiveRegister = true;
                    this.lastDrop = e;
                }
                this.DropActive = false;
            }
            if(e != 'flags' && e != 'register'){
                this.lastDrop = '';
            }
        },
        closeDrop(){
            if(this.isDrop == false){
                this.DropActive = false;
                this.DropActiveRegister = false;
            }  
        },
        logout(){
            localStorage.removeItem('token');
            localStorage.removeItem('userData');
            
            if(this.actualPage == '/'){
                location.reload();
            }else{
                this.$router.push({ name: 'homeLang'});
            }
        },
        goTo(val){
            try{
                location.href = val;
            }catch(e){

            }
        }
    }

}
</script>